var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.6667 0H5.33333C1.92889 0 0 1.92889 0 5.33333V14.6667C0 18.0622 1.92 20 5.33333 20H14.6667C18.0711 20 20 18.0622 20 14.6667V5.33333C20 1.92889 18.0711 0 14.6667 0Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3205 10.7083H10.7495V13.257C10.7495 13.6673 10.4139 14 10 14C9.58605 14 9.25048 13.6673 9.25048 13.257V10.7083H6.67955C6.29342 10.6687 6 10.3461 6 9.96132C6 9.5765 6.29342 9.25394 6.67955 9.21431H9.24242V6.67365C9.28241 6.29088 9.60778 6 9.99597 6C10.3842 6 10.7095 6.29088 10.7495 6.67365V9.21431H13.3205C13.7066 9.25394 14 9.5765 14 9.96132C14 10.3461 13.7066 10.6687 13.3205 10.7083Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.4c527fb3b0903df463b9a9f0cb2abb32.svg";
export { ForwardRef as ReactComponent };